module.exports = __webpack_public_path__ + "img/hr-stone-path.ecfcccd9.png";